module.exports = __webpack_public_path__ + "static/img/management-02.581fabd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/management-02.png
// module id = Z9UQ
// module chunks = 0